import * as React from "react"
import { Context } from "@contexts/PlanDataCtx.tsx"

const usePlanDataCtx = () => React.useContext(Context)

export default usePlanDataCtx
